<template>
  <RevChip
    v-bind="$attrs"
    :aria-expanded="isActive"
    :has-dropdown="true"
    :label="facet.title"
    :model-value="selectedLabels"
    size="medium"
    @click="openDrawer"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Facet } from '@backmarket/nuxt-layer-recommendation/filtering/types'
import { useFullscreenFilters } from '@backmarket/nuxt-layer-recommendation/filtering/useFullscreenFilters'
import { RevChip } from '@ds/components/Chip'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  facet: Facet
  selectedValues: string[]
}>()

const { filter: openFullscreenFilter } = useFullscreenFilters()

const isActive = computed(() => props.selectedValues.length > 0)
const selectedLabels = computed(() =>
  props.selectedValues.map(
    (value) =>
      props.facet.values.find((facetValue) => facetValue.name === value)
        ?.label ?? value,
  ),
)

function openDrawer(event: MouseEvent): void {
  openFullscreenFilter(event as PointerEvent, props.facet)
}
</script>
